
import React, { useState } from 'react';
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import { Input } from '@/components/ui/input';
import { Button } from '@/components/ui/button';
import { Label } from '@/components/ui/label';
import { Youtube, Link } from 'lucide-react';

interface YouTubeInputProps {
  onUrlSubmit: (url: string) => void;
  disabled?: boolean;
}

export default function YouTubeInput({ onUrlSubmit, disabled }: YouTubeInputProps) {
  const [url, setUrl] = useState('');
  const [isValid, setIsValid] = useState(false);

  const validateYouTubeUrl = (url: string) => {
    const youtubeRegex = /^(https?:\/\/)?(www\.)?(youtube\.com|youtu\.be)\/.+/;
    return youtubeRegex.test(url);
  };

  const handleUrlChange = (value: string) => {
    setUrl(value);
    setIsValid(validateYouTubeUrl(value));
  };

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    if (isValid && url.trim()) {
      onUrlSubmit(url.trim());
    }
  };

  return (
    <Card>
      <CardHeader>
        <CardTitle className="flex items-center space-x-2">
          <Youtube className="h-5 w-5 text-red-600" />
          <span>YouTube URL</span>
        </CardTitle>
      </CardHeader>
      <CardContent>
        <form onSubmit={handleSubmit} className="space-y-4">
          <div className="space-y-2">
            <Label htmlFor="youtube-url">YouTube Video URL</Label>
            <div className="flex space-x-2">
              <div className="relative flex-1">
                <Link className="absolute left-3 top-1/2 transform -translate-y-1/2 h-4 w-4 text-gray-400" />
                <Input
                  id="youtube-url"
                  type="url"
                  placeholder="https://www.youtube.com/watch?v=..."
                  value={url}
                  onChange={(e) => handleUrlChange(e.target.value)}
                  className="pl-10"
                  disabled={disabled}
                />
              </div>
              <Button 
                type="submit" 
                disabled={!isValid || disabled}
                className="bg-red-600 hover:bg-red-700"
              >
                Load Video
              </Button>
            </div>
            {url && !isValid && (
              <p className="text-sm text-red-600">Please enter a valid YouTube URL</p>
            )}
          </div>
        </form>
      </CardContent>
    </Card>
  );
}
